import { useIntl, defineMessages } from 'react-intl';

import MovieActiveIcon from '@/material-icons/400-24px/movie-fill.svg?react';
import MovieIcon from '@/material-icons/400-24px/movie.svg?react';
import SmartDisplayActiveIcon from '@/material-icons/400-24px/smart_display-fill.svg?react';
import SmartDisplayIcon from '@/material-icons/400-24px/smart_display.svg?react';
import { ColumnLink } from 'mastodon/features/ui/components/column_link';

import { CollapsiblePanel } from './collapsible_panel';

const messages = defineMessages({
  videos: { id: 'navigation_bar.videos', defaultMessage: 'Videos' },
  clips: { id: 'navigation_bar.clips', defaultMessage: 'Clips' },
  fullVideos: {
    id: 'navigation_bar.full_videos',
    defaultMessage: 'Videos',
  },
  expand: {
    id: 'navigation_panel.expand_videos',
    defaultMessage: 'Expand videos menu',
  },
  collapse: {
    id: 'navigation_panel.collapse_videos',
    defaultMessage: 'Collapse videos menu',
  },
});

export const VideosPanel: React.FC = () => {
  const intl = useIntl();

  return (
    <CollapsiblePanel
      icon='play'
      iconComponent={SmartDisplayIcon}
      activeIconComponent={SmartDisplayActiveIcon}
      title={intl.formatMessage(messages.videos)}
      collapseTitle={intl.formatMessage(messages.collapse)}
      expandTitle={intl.formatMessage(messages.expand)}
    >
      <ColumnLink
        transparent
        to='/clips'
        icon='play'
        iconComponent={MovieIcon}
        activeIconComponent={MovieActiveIcon}
        text={intl.formatMessage(messages.clips)}
      />
      <ColumnLink
        transparent
        to='/videos'
        icon='play'
        iconComponent={SmartDisplayIcon}
        activeIconComponent={SmartDisplayActiveIcon}
        text={intl.formatMessage(messages.fullVideos)}
      />
    </CollapsiblePanel>
  );
};
